export const keywordScreen = {
  ordering: 'Ordering',
  payment: 'Payment',
}

// Tương lai sẽ bổ sung thêm một status  nữa khi làm màn hình cuối thanh toán bình thường
export const PARAMS_STATUS_PAYMENT = {
  SUCCESS: 'success',
  FAILED: 'failed',
}

export const PARAMS_REDIRECT_PAYOO = {
  STATUS: 'status',
  TOKEN: 'token',
  CHECKSUM: 'checksum',
  ORDER_NO: 'order_no',
  ERROR_MESSAGE: 'errormsg',
}

export const SEARCH_PARAMS_REVIEW = {
  ref: 'ref',
}

// Những giá trị có thể là của params ref
export const VALUE_REF_PARAMS = {
  banner: 'banner',
}

export const BANNER_ID_PARAM = 'banner_id'
